import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=7eb51a36&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb51a36')) {
      api.createRecord('7eb51a36', component.options)
    } else {
      api.reload('7eb51a36', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=7eb51a36&", function () {
      api.rerender('7eb51a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Faq.vue"
export default component.exports